import React from 'react';
import logo from './Eidefut header.png';

const Navigation = ({ changeRoute }) => {
	//Using hook
	const [isClicked, setIsClicked] = React.useState(false);

	//Controls class of menu item
	let menuClass;
	if (isClicked){
		menuClass = 'menu is-active';
	} else {
		menuClass = 'menu'
	}

	return(
		<div>
	    	<i className="icon-menu burger-button" onClick={()=>{
	    		setIsClicked(!isClicked);
	    	}}></i>
			<header className="header">
			<div className="myContainer">
			  <figure>
			    <img src={logo} height="150" alt="Logo"/>
	 		 </figure>
				<nav className={menuClass}>
				    <ol>
					      <li>
					        <a className="noColor" href="#inicio" onClick={() => changeRoute('home')}><b>Inicio</b></a>
					      </li>
					      <li>
					        <a className="noColor" href="#vision" onClick={() => changeRoute('vision')}><b>Visión</b></a>
					      </li>
					      <li>
					        <a className="noColor" href="#anuncios" onClick={() => changeRoute('anuncios')}><b>Anuncios</b></a>
					      </li>
					      <li>
					        <a className="noColor" href="#eventos" onClick={() => changeRoute('eventos')}><b>Eventos</b></a>
					      </li>
					      <li>
					        <a className="noColor" href="#equipo" onClick={() => changeRoute('equipo')}><b>Equipo</b></a>
					      </li>
					      <li>
					        <a className="noColor" href="#media" onClick={() => changeRoute('media')}><b>Multimedia</b></a>
					      </li> 
					      <li>
					        <a className="noColor" href="#inscripciones" onClick={() => changeRoute('inscripcion')}><b>Inscripciones</b></a>
					      </li> 
					      <li>
					        <a className="noColor" href="#acerca" onClick={() => changeRoute('acerca')}><b>Acerca de</b></a>
					      </li>
				    </ol>
		    	</nav>
				
			</div>
			</header>
		</div>)

}

export default Navigation;